module.exports = __webpack_public_path__ + "media/images/icons/flags/MM-f8b1a8a779734781efe71c3aa26cd07c.svg";